import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AdminPlans() {
  const [plans, setPlans] = useState([]);
  const [form, setForm]   = useState({ name:'', duration_days:30, price:'', description:'', features:'' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]     = useState('');

  const load = () => axios.get('/admin/plans').then(r => setPlans(r.data));
  useEffect(() => { load(); }, []);

  const handleSave = async e => {
    e.preventDefault(); setSaving(true); setMsg('');
    try {
      await axios.post('/admin/plans', { ...form, features: form.features.split('\n').filter(Boolean) });
      setMsg('Plan created.'); setForm({ name:'', duration_days:30, price:'', description:'', features:'' }); load();
    } catch { setMsg('Error saving plan.'); }
    finally { setSaving(false); }
  };

  const toggle = async (id, is_active) => {
    await axios.put(`/admin/plans/${id}`, { ...plans.find(p => p.id===id), is_active: is_active ? 0 : 1 }); load();
  };

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Membership plans</h1><p className="page-sub">Manage your gym packages</p></div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:18 }}>
        <div>
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {plans.map(p => (
              <div key={p.id} className="card" style={{ padding:18, opacity: p.is_active ? 1 : .5 }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
                  <div style={{ fontSize:15, fontWeight:600 }}>{p.name}</div>
                  <div style={{ fontFamily:'var(--font-display)', fontSize:18, fontWeight:700, color:'var(--accent)' }}>₨{Number(p.price).toLocaleString()}</div>
                </div>
                <div style={{ fontSize:12, color:'var(--text-muted)', marginBottom:10 }}>{p.duration_days} days · {p.description}</div>
                {Array.isArray(JSON.parse(p.features||'[]')) && (
                  <ul style={{ listStyle:'none', display:'flex', flexDirection:'column', gap:4 }}>
                    {JSON.parse(p.features||'[]').map((f,i) => (
                      <li key={i} style={{ fontSize:12, color:'var(--text-secondary)', display:'flex', gap:6 }}>✓ {f}</li>
                    ))}
                  </ul>
                )}
                <div style={{ marginTop:12, display:'flex', gap:8 }}>
                  <button className={p.is_active ? 'btn-danger' : 'btn-ghost'} style={{ fontSize:12, padding:'5px 12px' }} onClick={() => toggle(p.id, p.is_active)}>
                    {p.is_active ? 'Deactivate' : 'Activate'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="card-header"><div className="card-title">➕ Add new plan</div></div>
          <form onSubmit={handleSave} style={{ padding:20 }}>
            {msg && <div style={{ marginBottom:14, padding:'10px 14px', borderRadius:'var(--radius)', background:'var(--success-dim)', color:'var(--success)', fontSize:13 }}>{msg}</div>}
            <div className="form-group"><label className="label">Plan name *</label><input className="input" placeholder="e.g. Monthly Basic" value={form.name} onChange={e => setForm(p=>({...p,name:e.target.value}))} required /></div>
            <div className="form-row">
              <div className="form-group"><label className="label">Duration (days) *</label><input className="input" type="number" value={form.duration_days} onChange={e => setForm(p=>({...p,duration_days:e.target.value}))} required /></div>
              <div className="form-group"><label className="label">Price (₨) *</label><input className="input" type="number" value={form.price} onChange={e => setForm(p=>({...p,price:e.target.value}))} required /></div>
            </div>
            <div className="form-group"><label className="label">Description</label><input className="input" placeholder="Short description" value={form.description} onChange={e => setForm(p=>({...p,description:e.target.value}))} /></div>
            <div className="form-group">
              <label className="label">Features (one per line)</label>
              <textarea className="input" rows={4} placeholder={"Full gym access\nLocker room\nProgress tracking"} value={form.features} onChange={e => setForm(p=>({...p,features:e.target.value}))} style={{ resize:'vertical' }} />
            </div>
            <button className="btn-primary" type="submit" disabled={saving} style={{ width:'100%', justifyContent:'center' }}>{saving ? 'Saving…' : 'Create plan'}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
